import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const nav = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
      padding: 0 ${spacing.xl}px;
      border-bottom: 1px solid var(--neutral-black-30);
    `,
  )};
`;

export const list = css`
  list-style-type: none;
  max-width: ${pxToRem(minBreakpoints.XL)};
  display: flex;
  margin: 0 auto;
  padding: 0;
  justify-content: center;
`;
